import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { STATUS_SUCCEEDED, useResourceValues } from 'src/presentation/hooks/useResource';
import voiceConfigurationResource from 'src/actions/channels/voiceConfigurationResource';
import VoiceConfiguration from 'src/models/Channels/VoiceConfiguration';

export default function useActivateNumberForVoice({ add, isActive, nextStep, saveStep, validate, resetErrors }) {
  const dispatch = useDispatch();
  const { persistingState } = useResourceValues(voiceConfigurationResource);
  const [voiceConfiguration, setVoiceConfiguration] = useState<VoiceConfiguration>();
  const [requestSent, setRequestSent] = useState(false);

  const activateNumber = (voiceConfiguration: VoiceConfiguration) => {
    dispatch(resetErrors());

    if (!dispatch(validate(voiceConfiguration))) {
      return;
    }

    setVoiceConfiguration(voiceConfiguration);

    dispatch(
      add(voiceConfiguration, undefined, {
        disableWindowBack: true,
        withoutToast: true,
      })
    );
    setRequestSent(true);
  };

  const isPersisting = 'persisting' === persistingState;

  useEffect(() => {
    if (requestSent && persistingState === STATUS_SUCCEEDED && isActive) {
      setRequestSent(false);
      saveStep({ ivr: voiceConfiguration });
      nextStep();
    }
  }, [isActive, persistingState, nextStep, saveStep, voiceConfiguration, requestSent, setRequestSent]);

  return { activateNumber, isPersisting };
}
